import { JSX, useState } from "react";
import { Notice, SelectField } from "@hatch-digital-nl/abs-storybook/legacy";
import { InfiniteImage } from "../svg/InfiniteImage";
import { History } from "../svg/History";
import { ValidityPeriodInterface } from "../interfaces/ValidityPeriodInterface";
import { QualificationValidityTypeEnum } from "../enums/QualificationValidityTypeEnum";
import { getValidityPeriodDisplay } from "../utils/getValidityPeriodDisplay";
import { useAssociatedFieldId } from "../utils/useAssociatedFieldId";

interface Props {
    id: number;
    options: {
        label: string;
        value: string;
    }[];
    onChange: (newValue: { value: string; label: string }) => void;
    value: {
        value: string;
        label: string;
    };
    onInputChange?: (inputValue: string) => void;
    inputValue?: string;
    errorMessage: string;
    placeHolder: string;
    title: string;
    validityPeriod?: ValidityPeriodInterface | null;
    validityType?: QualificationValidityTypeEnum | null;
    fixedValidUntil?: string | null;
    showValidityPeriod?: boolean;
    showNotice?: boolean;
    noticeText?: string;
    isLoading?: boolean;
}

export const SelectFieldComponent = (props: Props): JSX.Element => {
    const {
        id,
        onChange,
        value,
        onInputChange,
        inputValue,
        errorMessage,
        placeHolder,
        options,
        title,
        validityPeriod,
        validityType,
        fixedValidUntil,
        showValidityPeriod,
        showNotice,
        noticeText,
        isLoading = false,
    } = props;
    const [selectInputValue, setSelectInputValue] = useState<string>("");

    const [selectFieldError, setSelectFieldError] = useState<{
        [key: string]: string | null;
    }>({});

    const validityPeriodNew = getValidityPeriodDisplay({
        validityPeriod,
        validityType,
        fixedValidUntil,
    });

    const handleInputChange = (selectValue: string): void => {
        setSelectInputValue(selectValue);
    };
    const { fieldId, fieldRef } = useAssociatedFieldId();

    return (
        <div className={"c-form__form-group"}>
            <label htmlFor={fieldId}>{title}</label>
            <div ref={fieldRef}>
                <SelectField
                    placeHolder={placeHolder}
                    options={options}
                    searchIcon={true}
                    required={true}
                    onChange={onChange}
                    value={value?.value ? value : null}
                    onInputChange={onInputChange || handleInputChange}
                    inputValue={inputValue || selectInputValue}
                    onBlur={() => {
                        if (!value?.value && errorMessage) {
                            setSelectFieldError((prevErrors) => ({
                                ...prevErrors,
                                [id]: errorMessage,
                            }));
                            return;
                        }

                        setSelectFieldError((prevErrors) => ({
                            ...prevErrors,
                            [id]: null,
                        }));
                    }}
                    error={!!selectFieldError[id]}
                    isLoading={isLoading}
                />
            </div>
            {selectFieldError[id] && (
                <p className={"c-error-message"}>{selectFieldError[id]}</p>
            )}
            {showValidityPeriod && validityPeriodNew && value.value && (
                <div className={"c-form__form-group__expired-at"}>
                    {validityPeriodNew.icon === "INFINITE" ? (
                        <InfiniteImage />
                    ) : (
                        <History />
                    )}
                    <p>{validityPeriodNew.text}</p>
                </div>
            )}
            {showNotice && noticeText && (
                <div className={"c-form__form-group__notice"}>
                    <Notice htmlContent={`<p>${noticeText}</p>`} />
                </div>
            )}
        </div>
    );
};
